/** 설계·청약 FCM targetScreen → 웹 SPA 경로 (목록 화면만, 개별 건 상세 없음) */

const TARGET_SCREEN_PATHS = {
  'design-management': '/design-management',
  'design-request-response': '/design-request-response',
  'subscription-request-management': '/subscription-request-management',
  'subscription-receive-management': '/subscription-receive-management',
};

/** 백엔드 targetScreen 미포함 시 eventType으로 폴백 */
const DESIGN_EVENT_SCREENS = {
  DESIGN_REQUEST_ACCEPTED: 'design-management',
  DESIGN_RESULT_SUBMITTED: 'design-management',
  DESIGN_RESULT_RESUBMITTED: 'design-management',
  DESIGN_RESULT_CONTENT_UPDATED: 'design-management',
  DESIGN_RESULT_BASIC_INFO_UPDATED: 'design-management',
  DESIGN_REQUEST_CREATED: 'design-request-response',
  DESIGN_RECEIVER_ADDED: 'design-request-response',
  DESIGN_SUPPLEMENT_REQUESTED: 'design-request-response',
  DESIGN_RESULT_MATCHED: 'design-request-response',
  DESIGN_REQUEST_CANCELLED: 'design-request-response',
  DESIGN_MATCH_CANCELLED: 'design-request-response',
  DESIGN_REQUEST_CONTENT_UPDATED: 'design-request-response',
  DESIGN_RESULT_CONFIRMED_ATTACHMENT_UPDATED: 'design-request-response',
};

const SUBSCRIPTION_EVENT_SCREENS = {
  SUBSCRIPTION_RESULT_SUBMITTED: 'subscription-request-management',
  SUBSCRIPTION_RESULT_CONTENT_UPDATED: 'subscription-request-management',
  SUBSCRIPTION_REQUEST_CREATED: 'subscription-receive-management',
  SUBSCRIPTION_MATCHED: 'subscription-receive-management',
  SUBSCRIPTION_REQUEST_CANCELLED: 'subscription-receive-management',
  SUBSCRIPTION_CONFIRMATION_CANCELLED: 'subscription-receive-management',
  SUBSCRIPTION_REQUEST_CONTENT_UPDATED: 'subscription-receive-management',
};

export function resolveBusinessTargetScreen({ pushType, eventType, targetScreen } = {}) {
  const screen = targetScreen != null ? String(targetScreen).trim() : '';
  if (screen && TARGET_SCREEN_PATHS[screen]) {
    return screen;
  }
  const type = pushType != null ? String(pushType).trim() : '';
  const event = eventType != null ? String(eventType).trim() : '';
  if (type === 'design') {
    return DESIGN_EVENT_SCREENS[event] || 'design-request-response';
  }
  if (type === 'subscription') {
    return SUBSCRIPTION_EVENT_SCREENS[event] || 'subscription-receive-management';
  }
  return null;
}

export function buildBusinessPushClickPath({ pushType, eventType, targetScreen } = {}) {
  const screen = resolveBusinessTargetScreen({ pushType, eventType, targetScreen });
  if (!screen) {
    return '/dashboard';
  }
  return TARGET_SCREEN_PATHS[screen] || '/dashboard';
}

export function isBusinessPushType(pushType) {
  const type = pushType != null ? String(pushType).trim() : '';
  return type === 'design' || type === 'subscription';
}

/** App이 수신해 navigate(+같은 화면이면 remount/재조회) */
export const PUSH_NAVIGATE_EVENT = 'gopai:push-navigate';

/** location.state 키 — 값 변경 시 Routes remount로 목록 재조회 */
export const PUSH_REFRESH_STATE_KEY = 'pushRefreshAt';

/** SW·포그라운드 알림 클릭 공통 진입점 */
export function requestPushNavigate(url) {
  if (typeof window === 'undefined' || url == null || String(url).trim() === '') {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(PUSH_NAVIGATE_EVENT, { detail: { url: String(url) } })
  );
}
